export const CompFactorConstants: {[key: string]: string} = {
    additionalIncome: 'Additional Income',
    aircraftType: 'Aircraft Type',
    annualBonus: 'Annual Bonus',
    annualHotelRevenue: 'Annual Hotel Revenue',
    annualHotelRevenueCurrency: 'Currency (Annual Hotel Revenue)',
    annualSalesCommissions: 'Annual Sales Commissions',
    annualSalesCommissionsCurrency: 'Currency (Annual Sales Commissions)',
    annualSalesVolume: 'Annual Sales Volume',
    annualStoreRevenue: 'Annual Store Revenue',
    annualStoreRevenueCurrency: 'Currency (Annual Store Revenue)',
    assetsManaged: 'Assets Managed',
    assetsManagedCurrency: 'Currency (Assets Managed)',
    averageSalePrice: 'Average Sale Price',
    averageSalePriceCurrency: 'Currency (Average Sale Price)',
    averageSizeCompetitor: 'Average Competitor Size',
    avgRoomRate: 'Average Room Rate',
    avgRoomRateCurrency: 'Currency (Average Room Rate)',
    budgetUnderManagement: 'Budget Under Management',
    budgetUnderManagementCurrency: 'Currency (Budget Under Management)',
    certifications: 'Certifications',
    city: 'City',
    companySales: 'Company Sales',
    companySalesCurrency: 'Currency (Company Sales)',
    country: 'Country',
    currency: 'Currency',
    degrees: 'Degrees',
    employerProductActivity: 'Employer Product Activity',
    filingStatus: 'Filing Status',
    governmentContractor: 'Government Contractor?',
    gradeSchedule: 'Grade Schedule',
    gradeTaught: 'Grade Taught',
    highestDegreeEarned: 'Degree Type',
    hospitalBedSize: 'Hospital Bed Size',
    hospitalSetting: 'Hospital Setting',
    hotelService: 'Hotel Service',
    hotelType: 'Hotel Type',
    hourlyPay: 'Hourly Pay',
    hoursPerWeek: 'Hours Per Week',
    industry: 'Industry',
    internalJobTitle: 'Internal Job Title',
    jobCode: 'Job Code',
    jobResponsibilities: 'Job Responsibilities',
    jobTitle: 'Job Title',
    laborMarketCustomGroup1: 'Labor Market Custom Group 1',
    laborMarketCustomGroup2: 'Labor Market Custom Group 2',
    laborMarketDisplayName: 'Labor Market Display Name',
    loanPortfoliosManaged: 'Loan Portfolios Managed',
    managementRole: 'Supervisory Role',
    martindaleHubbellRating: 'Martindale Hubbell Rating',
    monthlyHoursPerWeek: 'Hours Per Week (Monthly)', // TODO: get this checked
    monthlyPay: 'Monthly Pay',
    numberOfLawyers: 'Number of Lawyers',
    numberOfPartners: 'Number of Partners',
    numberSupervised: 'Number Supervised',
    organizationType: 'Organization Type',
    overtimeHours: 'Overtime Hours',
    overtimeRate: 'Overtime Rate',
    payType: 'Pay Type',
    peopleManagementTasks: 'People Management Skills',
    peopleTypesManaged: 'Highest Level Managed',
    physicianPracticingStatus: 'Physician Practicing Status',
    pilotCertificate: 'Pilot Certificate',
    pilotCertificateClass: 'Pilot Certificate Class',
    portfoliosManaged: 'Portfolios Managed',
    portfoliosManagedCurrency: 'Currency (Portfolios Managed)',
    practiceArea: 'Practice Area',
    profitShare: 'Profit Share',
    profitShareCurrency: 'Currency (Profit Share)',
    publicationCirculation: 'Publication Circulation',
    publicationFrequency: 'Publication Frequency',
    region: 'Region',
    salaryHoursPerWeek: 'Hours Per Week (Salary)', // TODO: get this checked
    salesCommissionCurrency: 'Currency (Sales Commission)',
    salesCommissionRate: 'Sales Commission Rate',
    salesCommissionYearlySales: 'Annual Sales Commission',
    salesCustomerType: 'Sales Customer Type',
    salesQuotaPercentage: 'Sales Quota Percentage',
    salesTerritory: 'Sales Territory',
    securityClearanceStatus: 'Security Clearance Status',
    securityClearanceType: 'Security Clearance Type',
    signingAuthority: 'Signing Authority',
    signingAuthorityAmountAuthorized: 'Signing Authority Amount Authorized',
    signingAuthorityAmountAuthorizedCurrency: 'Currency (Signing Authority Amount Authorized)',
    skills: 'Skills',
    state: 'State',
    stockExchangeListing: 'Stock Exchange Listing',
    storesManaged: 'Stores Managed',
    tasks: 'Tasks',
    tenured: 'Tenured',
    travelFrequency: 'Travel Frequency',
    travelPercentage: 'Travel Percentage',
    travelType: 'Travel Type',
    ventureCapitalFocus: 'Venture Capital Focus',
    ventureCapitalType: 'Venture Capital Type',
    weeklyTips: 'Weekly Tips',
    workShift: 'Work Shift',
    yearlyPay: 'Annual Salary',
    yearsExperience: 'Years Experience',
    yearsMinimum: 'Minimum Years',
};
